"use client";

import { useMemo } from "react";
import useSWR from "swr";

import { fetcher } from "@aprosoja/api";
import { GetCategoriesData, GetNewsData } from "@aprosoja/types";

const useNewsList = () => {
  const { data: categoriesData } = useSWR<GetCategoriesData>(
    [`/categories?status=true`],
    async ([url]) => fetcher(url),
    { revalidateOnMount: true, revalidateOnFocus: false }
  );

  const { data: featuredNews, isLoading: featuredNewsIsLoading } =
    useSWR<GetNewsData>(
      [`/news?status=true&highlight=true`],
      async ([url]) => fetcher(url),
      {
        revalidateOnMount: true,
        revalidateOnFocus: false,
      }
    );

  const orderedFeaturedNews = useMemo(
    () =>
      featuredNews?.data.sort((a, b) => {
        return (
          new Date(a.createdAt as string).getTime() -
          new Date(b.createdAt as string).getTime()
        );
      }) ?? [],
    [featuredNews]
  );
  const firstTwoRecentFeaturedNews = orderedFeaturedNews.slice(0, 1);
  const remainingRecentFeaturedNews = orderedFeaturedNews.slice(1, 5);

  const categories = useMemo(
    () => categoriesData?.data ?? [],
    [categoriesData]
  );

  return {
    categories,
    firstTwoRecentFeaturedNews,
    remainingRecentFeaturedNews,
    featuredNewsIsLoading,
  };
};

export default useNewsList;
